module.exports = __webpack_public_path__ + "static/media/Merlin.51f22f8c.jpg";